import { popupActions } from './actions'
import { ActionType, createReducer, isActionOf } from 'typesafe-actions'

export interface PopupState {
  top: number
  left: number
  visible: boolean
}

export const popupReducer = createReducer<
  PopupState,
  ActionType<typeof popupActions>
>({
  left: window.innerWidth / 2 + window.pageXOffset,
  top: window.innerHeight / 2 + window.pageYOffset,
  visible: false
})
  .handleAction(popupActions.popup.position.set, (state, { payload }) => ({
    ...state,
    left: payload.left,
    top: payload.top
  }))
  .handleAction(
    [popupActions.popup.hide, popupActions.popup.show],
    (state, action) => ({
      ...state,
      visible: !!isActionOf(popupActions.popup.show, action)
    })
  )
